import React from 'react'
import './Footer.css'

function Footer() {
  return (
    <div className='Footer'>
      <div className="footer-cards">
        <div>
          <h1>Code Wise <b>Studio</b></h1>
          <p>© 2023 Crator Studio.</p>
          <p>All rights reserved.</p>
        </div>

        <div>
          <h3>Get in touch</h3>
          <p>123 W. Kanu Street</p>
          <p>Nairobi, CBD 90001</p>
          <br />
          <p>(+254) 742-1646-15</p>
          <p>kenabdi21@gmail.com</p>
        </div>

        <div>
          <h3>Company</h3>
          <p>Home</p>
          <p>Service</p>
          <p>About</p>
          <p>Work</p>
          <p>Contact Us</p>
        </div>

        <div>
          <h3>Follow us on social media</h3>
          <p>Stay connected and updated on <br /> our latest projects.</p>
          <div className="Footer-icons">
            <div>
            <i class="fab fa-instagram"></i>
            </div>
            <div>
            <i class="fab fa-facebook-f"></i>
            </div>
            <div>
            <i class="fab fa-twitter-square"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Footer